/* @flow */

import React from 'react';

type $Props = {
  icon: string,
  modifierClass?: string,
  onClick?: Function
};

const WorkbenchIcon = (props: $Props) => {
  return (
    <span className={props.modifierClass} onClick={props.onClick} dangerouslySetInnerHTML={{
      __html: props.icon
    }} />
  );
};

export default WorkbenchIcon;
